import React, { useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import _ from 'lodash-es';
import { sagaActions } from '../../../../../../../sagas/sagaActions';
import DrilldownTableSS from '../../../Dashboard/DefaultDashboard/DrillDownReports/Common/DrilldownTableSS';
import { getCSCEselector } from '../../../../../../../redux/reducers/reducerSlices/CSCEReducer';
import { capitalizeFirstLetter, formatDate_MM_DD_YYYY, getMessageType,showFileNameMessage } from '../../../../../../Assests/Utility';
import TinyLoader from '../../../../../Common/TinyLoader/TinyLoader';
import DatePickerSS from '../../../../../DatePickerSS/DatePickerSS';
import { AppConstant } from '../../../../../../Assests/AppConstant';
import CustomDropDown from "../../../../../Common/CustomDropDown/CustomDropDown";
import './CSCEMetric.css'
import CustomButtonSS from '../../../../../Common/CustomButton/CustomButtonSS';
import { getLivChatLogDetailsList } from '../../../../../../../redux/reducers/reducerSlices/GetLiveChatLogDetails';
import moment from 'moment';
import ChatDetails from '../ChatDetails/ChatDetails';

const CSCEMetrics = ({ themeSelected = 'light-mode' }) => {
    const dispatch = useDispatch();
    const divRef = useRef(null);
    const lastKeyRef = useRef(null); // ← keep track without re-rendering

    const { isLoading, metrics } = useSelector(getCSCEselector);
    const liveChatLogDetails = useSelector(getLivChatLogDetailsList);
    const [metricsData, setMetricsData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [showStartDate, setShowStartDate] = useState(false);
    const [showEndDate, setShowEndDate] = useState(false);
    const [maxEndDate, setMaxEndDate] = useState(new Date());
    const [selectedStartDate, setSelectedStartDate] = useState(null);
    const [selectedEndDate, setSelectedEndDate] = useState(null);
    const [currentFilterSelected, setCurrentFilterSelected] = useState({ name: 'All' });
    const [lastEvaluatedKeyForLiveChat, setLastEvaluatedKeyForLiveChat] = useState(null);
    const [chatInfiniteScroll, setChatInfiniteScroll] = useState(false);
    const [hasMoreLiveChat, setHasMoreLiveChat] = useState(true);
    const [messages, setMessages] = useState([]);
    const [fmessages, setFMessages] = useState([]);
    const [messageText, setMessageText] = useState('');
    const [showModal, setShowModal] = useState(false);
    const [selectedSessionID, setSelectedSessionID] = useState('');
    const [selectedID, setSelectedID] = useState('');
    const [chatScroll, setChatScroll] = useState(false);



    const titleDD = [
        { id: 'agentFirstName', name: 'Agent name' },
        { id: 'customerFirstName', name: 'Customer name' },
        { id: "startOn", name: "Started On" },
        { id: "endOn", name: "Ended On" },
        { id: 'responseTime', name: 'Response Time(min)' },
        { id: 'resolutionTime', name: 'Resolution Time(min)' },
        { id: "feedback", name: "Feedback" },
        { id: "chatLog", name: "Chat Logs" }
    ];

    useEffect(() => {
        if(!chatInfiniteScroll){
                setMessages([])
                setFMessages([])
        }

        let dataToSort = [];
        if (messages) {
            dataToSort = [...messages]
        }
        const newItems = Array.isArray(liveChatLogDetails?.data?.data?.Items)
        ? liveChatLogDetails?.data?.data?.Items
        : [];

        // dataToSort = [...dataToSort, ...newItems];
        if (!chatInfiniteScroll) {
            dataToSort = [...newItems]
          } else {
            dataToSort = [...dataToSort, ...newItems]
          }

        const sortedMessages = _.sortBy(dataToSort, 'createdOn');
        setLastEvaluatedKeyForLiveChat(liveChatLogDetails?.data?.data?.LastEvaluatedKey || null);
        setHasMoreLiveChat(!!liveChatLogDetails?.data?.data?.LastEvaluatedKey);
        setMessages(sortedMessages);
        setChatScroll(false);
    }, [liveChatLogDetails.data]);

    useEffect(() => {
        // when messages are set format message for ChatDetails component to consume data - ReactChatElements used
        if (_.size(messages)) {
          const formatMessages = messages.map((el, i) => {
            const documentType = getMessageType(el.documentType)
            return {
              position: el.senderType === 'CUSTOMER' ? 'right' : 'left',
              title: el.senderType === 'CUSTOMER' ? el.firstName : `Agent - ${el.firstName}`,
              type: documentType,
              text: getMessageType(el.documentType) === 'file' ? showFileNameMessage(el.documentName, el.message) : el.message, // Show both filename and message""}` : el.message, // Show both filename and message
              date: el.createdOn,
              data: {
                uri: el.documentURL,
                width: 200,
                height: 150,
                status: {
                  click: false,
                  download: false
                },
                ...el
              },
              className: el.senderType === 'CUSTOMER' ? 'right' : 'left'
            }
          })
          setFMessages([...formatMessages])

        }
        setChatScroll(false);
      }, [messages])

    const actionsButton = (elementData, index) => {
        return (
            <div className="m-0 p-0 d-flex justify-content-center">
                <CustomButtonSS
                    title={"View"}
                    className={
                        "addButton"
                    }
                    isLoading={false}
                    onClick={() => onclickChatLog(elementData)}
                    disabled={false}
                />
            </div>
        );
    };

    const onclickChatLog = (data) => {
        //open pop and start the loader until messages loads
        setShowModal(true);
        fetchChatLogData(data)
    };

    const fetchChatLogData = (chatDetails) => {
        setChatScroll(true);
        // if (isLoading || loading) return
        setSelectedID(chatDetails?.customerCUID);
        setSelectedSessionID(chatDetails?.sessionId);
        const params = {
            limit: 15,
            lastEvaluatedKey: lastEvaluatedKeyForLiveChat ? JSON.parse(JSON.stringify(lastEvaluatedKeyForLiveChat)) : null,
            id: chatDetails?.customerCUID,
            sessionId: chatDetails?.sessionId
        };
        dispatch({ type: sagaActions.CS_LIVE_CHAT_HISTORY_DETAILS, payload: params });

    };

    const fetchChatLogDataForInfinteScroll = (scroll,data) => {
        setChatScroll(true);
        // if (isLoading || loading) return
        setChatInfiniteScroll(scroll);
        const params = {
            limit: 15,
            lastEvaluatedKey: lastEvaluatedKeyForLiveChat ? JSON.parse(JSON.stringify(lastEvaluatedKeyForLiveChat)) : null,
            id: selectedID,
            sessionId: selectedSessionID
        };
        dispatch({ type: sagaActions.CS_LIVE_CHAT_HISTORY_DETAILS, payload: params });
    };
    
    const feedbackRatings = ({happinessLevel, communicationRating}) => {
        const renderStars = (count) => {
            return [...Array(5)].map((_, i) => (
                <span key={i} style={{ color: i < count ? 'gold' : '#ccc', fontSize: '1.2em' }}>
                    ★
                </span>
            ));
        };
    
        return (
            <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                <div>
                    <strong>Happiness: </strong>{renderStars(happinessLevel)}
                </div>
                <div>
                    <strong>Communication: </strong>{renderStars(communicationRating)}
                </div>
            </div>
        );
    };
    

    const formatListDataDrillDown = (data) => {
        return data.map((el, index) => ({
            0: el.agentFirstName ? capitalizeFirstLetter(el.agentFirstName) : '-',
            1: el.customerFirstName ? capitalizeFirstLetter(el.customerFirstName) : '-',
            2: el.createdOn ? el.createdOn : '-',
            3: el.chatEndOn ? el.chatEndOn : '-',
            4: el.responseTime ? Math.round(el.responseTime / 1000 / 60) : '-',
            5: el.resolutionTime ? Math.round(el.resolutionTime / 1000 / 60) : '-',
            6: feedbackRatings(el, index),
            7: actionsButton(el, index)
        }));
    };

    const getBodyData = () => formatListDataDrillDown(metricsData);

    const fetchData = () => {
        // if (isLoading || loading || lastKeyRef.current === null && metricsData.length > 0) return;
        if (isLoading || loading) return
        // setLoading(true);

        const params = {
            limit: 100,
            lastEvaluatedKey: lastKeyRef.current,
            crudType: 'S',
            startDate: moment(selectedStartDate).format(AppConstant.commonStrings.YYYY_MM_DD_T_HH_mm_ss),
            endDate: moment(selectedEndDate).format(AppConstant.commonStrings.YYYY_MM_DD_T_HH_mm_ss)
        };

        const operationObj = {
            type: 'Fetch Metrics',
            status: '',
        };

        dispatch({ type: sagaActions.GET_CSCE_METRICS, payload: params, operationObj });
    };

    /**
   * Function to handle startdate change
   * @param {*} date
   */
    const handleStartDate = (date) => {
        let threeMonthslater = new Date(date);
        threeMonthslater.setMonth(date.getMonth() + 3);
        if (threeMonthslater < selectedEndDate) {
            setSelectedEndDate(null);
        }
        setSelectedStartDate(date);
        getMaxEndDate(date);
    };

    /**
     * Function to return max end date
     */
    const getMaxEndDate = (startDate) => {
        let currentDate = new Date();
        let threeMonthslater = new Date(startDate);
        threeMonthslater.setMonth(startDate.getMonth() + 3);
        threeMonthslater.setDate(threeMonthslater.getDate() - 1);
        if (currentDate <= threeMonthslater) {
            setMaxEndDate(currentDate);
        } else {
            setMaxEndDate(threeMonthslater);
        }
    };

    const closepopup = () => {
        setShowModal(false);
        setSelectedID('');
        setSelectedSessionID('');
        dispatch({ type: sagaActions.RESET_LIVE_CHAT_HISTORY_DETAILS});
    };


    /**
     * This function is used to show the custom drop down filter
     * @returns
     */
    const showCustomDropDownForFilters = () => {
        const filterDataArr = [
            {
                name: "All",
            },
            {
                name: "Individual",
            },

        ];
        return (
            <div className="d-flex align-items-center">
                <div className="me-2 titleFiltersLeaveMeta">
                    {AppConstant.commonStrings.select} :
                </div>
                <CustomDropDown
                    themeSelected={themeSelected}
                    data={filterDataArr}
                    placeHolder={currentFilterSelected.name}
                    onSelect={(event) => setCurrentFilterSelected(event)}
                    keyStr={"name"}
                />
            </div>
        );
    }

    useEffect(() => {
        dispatch({ type: sagaActions.CLEAR_CSCE_METRICS });
        dispatch({ type: sagaActions.INITIATE_CSCE_METRICS_LOADER, payload: true });

        setMetricsData([]);
        lastKeyRef.current = null;

        const dStart = new Date();
        dStart.setHours(0, 0, 0, 0);

        const dEnd = new Date();
        dEnd.setHours(23, 59, 59, 0);

        setSelectedStartDate(dStart);
        setSelectedEndDate(dEnd);

        // setTimeout(() => {
        //     fetchData()
        // },100)

        return () => {
            dispatch({ type: sagaActions.CLEAR_CSCE_METRICS });
        };
    }, []);

    useEffect(() => {
        if (metrics?.Items?.length) {
            let items =  _.orderBy(metrics?.Items, ['createdOn'], ['desc']);
            setMetricsData(prev => [...prev, ...items]);
        }

        // Only reset `lastKeyRef` and `loading`, not the data
        lastKeyRef.current = metrics?.LastEvaluatedKey || null;
        setLoading(false);
    }, [metrics]);


    const handleScroll = _.debounce((e) => {
        const target = e.target;
        const nearBottom = target.scrollHeight - target.scrollTop <= target.clientHeight + 1;

        if (nearBottom && !isLoading && !loading && lastKeyRef.current !== null) {
            fetchData();
        }
    }, 200);

    useEffect(() => {
        const container = divRef.current;
        if (container) {
            container.addEventListener('scroll', handleScroll);
        }
        return () => {
            container?.removeEventListener('scroll', handleScroll);
            handleScroll.cancel();
        };
    }, [handleScroll]);

    useEffect(() => {
        if (selectedStartDate && selectedEndDate) {
            lastKeyRef.current = null;
            setMetricsData([]);
            fetchData();
        }
    }, [selectedStartDate, selectedEndDate]);


    return (

        <div className="pt-2">
            <div className="container-fluid d-flex py-2 text-start">
                <div className="d-flex appt-report-header gap-3 align-items-center">
                    <div className="pos-rel">
                        <div className="d-flex flex-column align-items-start">
                            <label className="boldText m-0 f-14">
                                <i className="fa-regular fa-calendar"></i> Start Date{" "}
                            </label>
                            <button
                                className={"datePickerBtn h-100 w-100"}
                                onClick={() => setShowStartDate(!showStartDate)}
                                disabled={false}
                            >
                                <span className="btn-title">
                                    {selectedStartDate
                                        ? formatDate_MM_DD_YYYY(selectedStartDate)
                                        : "Start Date"}
                                </span>
                                <i
                                    className="fa-regular fa-calendar"
                                    style={{ marginInline: "9px" }}
                                ></i>
                            </button>
                            {showStartDate && (
                                <div className="appt-summary-ss-datePicker csce-ss-datePicker">
                                    <DatePickerSS
                                        maxDate={new Date()}
                                        setSelectedDate={handleStartDate}
                                        selectedDate={selectedStartDate}
                                        closeCalendar={() => {
                                            setShowStartDate(!showStartDate);
                                        }}
                                    />
                                </div>
                            )}
                        </div>
                    </div>
                    <div className="pos-rel">
                        <div className="d-flex flex-column align-items-start">
                            <label className="boldText m-0 f-14">
                                <i className="fa-regular fa-calendar"></i> End Date{" "}
                            </label>

                            <button
                                className={"datePickerBtn h-100 w-100"}
                                onClick={() => setShowEndDate(!showEndDate)}
                                disabled={false}
                            >
                                <span className="btn-title">
                                    {selectedEndDate
                                        ? formatDate_MM_DD_YYYY(selectedEndDate)
                                        : "End Date"}
                                </span>
                                <i
                                    className="fa-regular fa-calendar"
                                    style={{ marginInline: "9px" }}
                                ></i>
                            </button>
                            {showEndDate && (
                                <div className="appt-summary-ss-datePicker">
                                    <DatePickerSS
                                        setSelectedDate={setSelectedEndDate}
                                        minDate={new Date(selectedStartDate)}
                                        maxDate={maxEndDate}
                                        selectedDate={selectedEndDate}
                                        closeCalendar={() => {
                                            setShowEndDate(!showEndDate);
                                        }}
                                    />
                                </div>
                            )}
                        </div>
                    </div>
                    {/* <div className="mt-3">{showCustomDropDownForFilters()}</div> */}
                </div>

            </div>

            <div className="csceContainer mt-1" ref={divRef}>
                    {/* <div className='' > */}
                        <DrilldownTableSS
                            key={Math.random()}
                            themeSelected={themeSelected}
                            bodyData={getBodyData()}
                            titleData={titleDD}
                            showCollapse={false}
                            showInput={false}
                            showSort={false}
                            hasCollapsableContent={false}
                            collapsableData={[]}
                            accordionPrimaryIndex={1}
                            drillDownReport={metrics?.Items}
                            initiateDrillDownReport={isLoading}
                            loaderArray={8}
                            sortingAction={sagaActions.SORT_SS_USER_TABLE}
                            subRoot={{ pathName: '' }}
                            showUTCTime={true}
                        />
                    {/* </div> */}

                {(isLoading || loading) && (
                    <div className='d-flex justify-content-center w-100'>
                        <TinyLoader />
                    </div>
                )}
                {showModal && (
                    <div className="custom-modal-overlay">
                        <div className="custom-modal-content">
                            <div className="modal-header d-flex justify-content-between align-items-center">
                                <h5 className="m-0">Chat Details</h5>
                                <button onClick={closepopup} className="btn btn-sm btn-danger">Close</button>
                            </div>
                            <div className="modal-body">
                                <ChatDetails
                                    activeSession={null}
                                    messages={fmessages}
                                    messageText={messageText}
                                    // userType={type}
                                    hasMoreLiveChat={hasMoreLiveChat}
                                    scrollLiveChatLoader={chatScroll}
                                    fetchLiveChatSessions={fetchChatLogDataForInfinteScroll}
                                    fullWidth={true}
                                    chatType={'HISTORY'}
                                    // apptype={apptype}
                                     />
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default CSCEMetrics;